import { simpleFetch } from './customFetch';

export const getOrderTracking = (orderShipmentIds: Array<number>) => {
  const options = {
    method: 'POST',
    body: JSON.stringify({ orderShipmentIds }),
  };
  return simpleFetch('/api/1/orders/trackings', options, process.env.REACT_APP_MY_ACCOUNT_API);
};
